<template>
<div id="app">
  <div id="loader-bg">
    <div id="loader"> <img src="/image/img-loading.gif" width="146" height="138" alt="Now Loading..." />
      <p>Now Loading...</p>
    </div>
  </div>
  <header>
    <div class="DSbtn">
      <div class="hambarg"></div>
      <div class="hambarg"></div>
      <div class="hambarg"></div>
    </div>
  </header>
  <nav class="gnavi">
    <ul>
      <li><a href="#app">Top</a></li>
      <li><a href="#c1">Introduction</a></li>
      <li><a href="#c2">Movie</a></li>
      <li><a href="#c3">Zipang Portable</a></li>
      <li><a href="#c4">How to Play</a></li>
      <li><a href="#c5">News</a></li>
    </ul>
    <div class="sns">
      <ul>
        <li><a href="https://www.facebook.com/ZipangGame/" target="_blank"><img src="/image/fbw.png" width="27" height="27" alt="facebook"></a></li>
        <li><a href="https://www.instagram.com/zipang_games/" target="_blank"><img src="/image/instaw.png" width="27" height="27" alt="instagram"></a></li>
        <!-- <li><a href="#"><img src="/image/tww.png" width="27" height="27" alt="twitter"></a></li>-->
        <li><a href="mailto:engine@engine-id.com"><img src="/image/mailw.png" width="27" height="27" alt="mail"></a></li>
      </ul>
    </div>
  </nav>
  <div id="wrapper">
    <section class="top">
      <div class="links">
        <ul class="clearfix">
          <li> <a href="https://bodoge.hoobby.net/market/items/3103" target="_blank"><span>購入はこちら</span></a></li>
          <li> <a href="/">JP</a> / <a href="/en/">EN</a></li>
        </ul>
      </div>
      <div class="mouse"><img src="/image/mouse.png" width="30" height="48" alt="SCROLL"/><span>SCROLL</span></div>
      <h1><img src="/image/logo.png" width="664" height="323" alt="戦国ジパング" /></h1>
      <div class="cloud01"><img src="/image/cloud_left.png" width="3646" height="965" alt=" " /></div>
      <div class="cloud02"><img src="/image/cloud_right.png" width="3635" height="1533" alt=" " /></div>
      <div class="main"></div>
    </section>
    <section class="intro" id="c1">
      <div class="read">
        <h1>Introduction</h1>
        <p class="catch">謀る、奪う、攻め滅ぼす！</p>
        <p>16世紀日本の戦国時代において、立身出世を志す一人の侍として万石コインの獲得を目指します。<br>
          合戦を繰り返した末に一番多くの万石コインを持っている者が戦乱の日本を天下統一し、<br>
          征夷大将軍となります。各合戦では、カードの効果（攻撃・防御・調略・万石コインを奪う 等）を使い、<br>
          相手の作戦や手札を予想しながら行動します。<br>
          各キャラクターカードはそれぞれの効果の他に、武力（BATTLEポイント）と名誉（HONORポイント）を<br>
          持ちます。武力と名誉を使い分け、時に力で、時に策略で、万石コインを奪い合うゲームです。</p>
        <a href="https://bodoge.hoobby.net/market/items/3103" target="_blank"><span>Go to hoobby</span></a> </div>
      <img src="/image/samurai_left.png" width="457" height="571" alt="侍" class="samurai01" /> <img src="/image/samurai_right.png" width="398" height="808" alt="侍" class="samurai02" /> <img src="/image/shadow_001.png" width="690" height="138" alt=" " class="shadow01" /> <img src="/image/shadow_002.png" width="836" height="703" alt=" " class="shadow02" /> <img src="/image/shadow_003.png" width="725" height="492" alt=" " class="shadow03" /> </section>
    <section class="mov" id="c2">
      <div class="movieBlock">
        <div id="video-background">
          <youtube :video-id="videoId" :player-vars="playerVars" ref="youtube" @ended="ended" id="player"></youtube>
        </div>
        <div id="video-overlay" @click="videoPlayHandler()" v-bind:class="{show:enhance}">
          <div class="playBtn"><span class="playbx">MOVIE<br>
            <img src="/image/play.png" alt="play"></span></div>
        </div>
        <div id="video-overlay_stop" @click="videoPauseHandler()" v-bind:class="{hide:enhance}">
          <div class="playBtn"></div>
        </div>
        <div id="video-overlay_mute" @click="videoMuteHandler()" class="mute" v-bind:class="{on:muting}">
          <div class="muteBtn"><span>Mute:</span></div>
        </div>
        <div id="video-overlay_unmute" @click="videoUnmuteHandler()" class="mute" v-bind:class="{off:muting}">
          <div class="unmuteBtn"><span>Mute:</span></div>
        </div>
      </div>
	  <div class="mov_box">
		<iframe width="560" height="315" src="https://www.youtube.com/embed/0KXUUmF7S9I?showinfo=0&modestbranding=1" frameborder="0" allowfullscreen></iframe>
	</div>
    </section>
    <section class="portable" id="c3">
      <Slick></Slick>
    </section>
    <section class="howto" id="c4">
      <h2>HOW TO PLAY</h2>
      <p class="read">戦國ZiPANGは合戦を繰り返してコインを奪い合うゲームです。 <br>
        最後に一番多くのコインを持っているプレイヤーが天下統一（勝ち）です。</p>
      <Slick02></Slick02>
      <div class="howtoBoxSp">
        <div class="flow flow01">
          <div class="flowBtn"><span>合戦の準備</span></div>
          <div class="deatil">
            <div class="deatil01">
              <h3>合戦の準備 ①</h3>
              <div class="photo"><img src="image/howto01sp.png" width="216" alt=""/></div>
              <p class="tl">各プレイヤーに<br>
                カード2枚、コイン5枚を配る。</p>
              <p>※2人プレイの場合はカード4枚<br>
                ※プレイヤーの数に応じて、山札からカードを取り除く。（別紙）</p>
            </div>
            <div class="deatil02">
              <h3>合戦の準備 ①</h3>
              <div class="photo"><img src="/image/howto02sp.png" width="260" alt=""/>
                <p>例）4人プレイの場合</p>
              </div>
              <p>山札は裏面にして各プレイヤーの中央に置く。 山札から一枚とり山札の横に<span>裏面にして置き</span>、これをカード置場とする。</p>
              <p>各プレイヤー1枚ずつ、中央にコインを出し、<span>その中の1枚は取り除く（箱の中などに入れておく）。</span></p>
              <p>いざ、合戦へ！</p>
            </div>
          </div>
        </div>
        <div class="flow flow02">
          <div class="flowBtn"><span>合　戦</span></div>
          <div class="deatil">
            <div class="deatil01">
              <h3>合戦 ①</h3>
              <div class="photo"><img src="/image/howto03sp.png" width="260" height="" alt=""/></div>
              <p class="tl">山札から1枚カードを引き、3枚になった手札の中から、使いたい効果を持つカード1枚を表向きにして置場に出す。</p>
              <p>※「一揆」するときは農民を同時に2枚出し、直ちに山札から1枚引き、手札を2枚に戻します。</p>
              <p>※相手からの攻撃でカードを失ったら、直ちに山札からカードを補充し手札を2枚に戻します。 </p>
            </div>
            <div class="deatil02">
              <h3>合戦 ②</h3>
              <p>合戦①を各プレイヤーが時計回りに行なっていき、<span>（a）</span>または<span>（b）</span>の条件になったプレイヤーが中央のコイン置場にある全てのコインを得られる。</p>
              <ul class="clearfix">
                <li>
                  <div class="base gr">
                    <div>
                      <p>・山札が全て無くなった時または<br>
                        ・帝カードが使われた時に</p>
                      <span class="cl ti">（a）</span> 手札のHONORポイントの合計が多いプレイヤー<br>
                      <span class="ti">（出された帝のポイントは含まれない）</span> </div>
                  </div>
                </li>
                <li>
                  <div class="base">
                    <div>または</div>
                  </div>
                </li>
                <li>
                  <div class="base gr">
                    <div><span class="cl ti">（b）</span>合戦の最後の一人</div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="deatil03">
              <h3>合戦 ③</h3>
              <p>次の合戦は、前の合戦の勝者からスタートする。（合戦の準備①へ）</p>
              <p><span>次の合戦を行うためのコインを持たない</span>プレイヤーが出たらゲーム終了。その時一番多くのコインを持っているプレイヤーが天下人となる。</p>
              <div class="photo"><img src="/image/howto04.png" width="180"  alt=""/></div>
            </div>
          </div>
        </div>
        <div class="flow flow03">
          <div class="flowBtn"><span>攻防について</span></div>
          <div class="deatil">
            <div class="deatil01">
              <h3>攻防について ①</h3>
              <div class="photo"><img src="/image/howto05sp.png" width="260" alt=""/></div>
              <p>武将、軍師、大名または農民2枚で相手に攻撃を仕掛け、勝てば合戦のサイクルから攻撃した相手を排除することができる。</p>
              <p>各合戦の自分の初ターン前に攻撃を受けた場合、コインを1枚払うことで攻撃をブロックできる。</p>
            </div>
            <div class="deatil02">
              <h3>攻防について ②</h3>
              <div class="photo"><img src="/image/howto06-2sp.png" width="252" alt=""/></div>
              <p class="mg">合戦①を各プレイヤーが時計回りに行なっていき、（a）または（b）の条件になったプレイヤーが中央のコイン置場にある全てのコインを得られる。</p>
              <div class="photo"><img src="/image/howto06-1sp.png" width="260" alt=""/></div>
              <p>攻撃側は攻撃に使用した<span class="bl">カード1枚のBTL</span>、<span class="rd">防御側は手札2枚の合計BTL</span>で勝負します。 BTL総数が攻撃側より少ない場合、合戦から除外され、次の合戦を待ちます。 攻撃側は負けても何も起きません。</p>
            </div>
          </div>
        </div>
		 <p class="rule">詳しくは<a href="/pdf/rulebook_zipang_jp.pdf" target="_blank">ルールブック[PDF]</a>をご確認ください。</p>
      </div>
      <div class="left"><img src="/image/samurai_L.png" alt=""/></div>
      <div class="right"><img src="/image/samurai_R.png" alt=""/></div>
    </section>
    <section class="news" id="c5">
      <h1>NEWS</h1>
      <div class="wrap">
        <dl v-for="(bl, i, key) of limitCount" :key="key" class="clearfix">
          <dt>
            <time :datetime="bl.date">{{ bl.date }}</time>
            </a> </dt>
          <dd> <a v-bind:href="bl.link" target="_blank">{{bl.title}}</a></dd>
        </dl>
      </div>
    </section>
  </div>
  <footer>
    <div class="sns">
      <ul>
        <li><a href="https://www.facebook.com/ZipangGame/" target="_blank"><img src="/image/fb.png" width="30" height="28" alt="facebook"></a></li>
        <li><a href="https://www.instagram.com/zipang_games/" target="_blank"><img src="/image/insta.png" width="30" height="28" alt="instagram"></a></li>
        <!-- <li><a href="#"><img src="/image/tw.png" width="30" height="28" alt="twitter"></a></li>-->
        <li><a href="mailto:engine@engine-id.com"><img src="/image/mail.png" width="30" height="28" alt="mail"></a></li>
      </ul>
    </div>
    <p class="copyright">Copyright  ENGINE-iD  Co., Ltd.  All rights reserved. </p>
  </footer>
</div>
</template>

<script>
import $ from 'jquery'
import Slick from '../src/components/slick'
import Slick02 from '../src/components/slick02'
export default {
	name: 'App',
	data() {
		return {
			blogList: [],
			enhance: true,
			muting: true,
			videoId: '0KXUUmF7S9I',
			playerVars: {
				rel: 0,
				autoplay: 0,
				controls: 0,
				autohide: 1,
				showinfo: 0,
				modestbranding: 1,
				wmode: 'transparent'
			}
		}
	},
	components: {
		Slick,
		Slick02,
	},
	methods: {
		getBlogs() {
			this.axios.get('https://sengoku-zipang.com/en/wp-json/wp/v2/posts').then(response => {
				for (let bl of response.data) {
					this.blogList.push({
						title: bl.title.rendered, // タイトル
						date: bl.date.slice(0, -9).replace(/-/g, '.'), // 日付
						link: bl.urls.links
					})
				}
			})
		},
		videoPlayHandler: function() {
			this.playVideo()
			this.EnhanceFlase()
		},
		videoPauseHandler: function() {
			this.pauseVideo()
			this.EnhanceTrue()
		},
		videoMuteHandler: function() {
			this.muteVideo()
			this.MuteFalse()
		},
		videoUnmuteHandler: function() {
			this.unmuteVideo()
			this.MuteTrue()
		},
		EnhanceFlase() {
			this.enhance = false
		},
		EnhanceTrue() {
			this.enhance = true
		},
		MuteFalse() {
			this.muting = false
		},
		MuteTrue() {
			this.muting = true
		},
		playVideo() {
			this.player.playVideo()
		},
		pauseVideo() {
			this.player.pauseVideo()
		},
		muteVideo() {
			this.player.mute()
		},
		unmuteVideo() {
			this.player.unMute()
		},
		ended() {
			this.player.playVideo()
		}
	},
	created: function() {
		this.getBlogs();
	},
	computed: {　　　
		limitCount() {　　　　
			return this.blogList.slice(0, 4)　　　
		},
		player() {
			return this.$refs.youtube.player
		}　　
	}
}

//jQery
$(function() {
	var h = $(window).height();　
	$('header').css('display', 'none');
	$('footer').css('display', 'none');
	$('#wrapper').css('display', 'none');
	$('#loader-bg ,#loader').height(h).css('display', 'block');
});
//トップアニメーション
function rect() {
	$(".cloud01").addClass('on');
	$(".cloud02").addClass('on');
	$('section.top h1').delay(600).queue(function() {
		$(this).addClass('on').dequeue();
	});
	$('section.top .main').delay(1500).queue(function() {
		$(this).addClass('on').dequeue();
		$(function() {
			setTimeout(function() {
				derect();
			}, 4000);
		});
	});
}
function derect() {
	$(".cloud01").removeClass('on');
	$(".cloud02").removeClass('on');
	$('section.top .main').delay(2000).queue(function() {
		$(this).removeClass('on').dequeue();
	});
	$('section.top h1').delay(2500).queue(function() {
		$(this).removeClass('on').dequeue();
		$(function() {
			setTimeout(function() {
				rect();
			}, 4000);
		});
	});
}
//画面サイズによる調整
function setSize() {
	var winW = $(window).width();
	var winH = $(window).height();
	$('section.mov').css({
		'height': winH
	});
	if (winW >= 960) {
		$('section.top').css({
			'height': winH,
			'width': winW
		});
	}
	if (winW < 960 && winW > 767) {
		$('section.top').css({
			'height': 540,
			'width': winW
		});
	}
	if (winW < 768) {
		$('section.top').css({
			'height': winH,
			'width': winW
		});
	}
}
function yt_screen_retio() {
	const WIN_H = $(window).height();
	const WIN_W = $(window).width();
	const screen_switch = 0.5625;
	const screen_ratio = WIN_H / WIN_W;
	const ratio_H = WIN_H / screen_switch;
	const ratio_W = WIN_W * screen_switch;
	if (screen_ratio > screen_switch) {
		$('#player').css({
			position: "absolute",
			height: "100%",
			width: ratio_H,
			"margin-top": "0",
			"margin-left": -ratio_H / 2,
			// "margin-left": -ratio_H,
			left: "50%",
			top: "0"
		});
	} else {
		$('#player').css({
			position: "absolute",
			width: "100%",
			height: ratio_W,
			"margin-top": -ratio_W / 2,
			"margin-left": "0",
			top: "50%",
			left: "0"
		});
	}
}
$(function() {
	setSize();
	yt_screen_retio();
	$(window).resize(function() {
		setSize();
		yt_screen_retio();
	});
});
//メニュー
$(function() {
	$('.DSbtn').click(function() {
		if ($('.DSbtn').is('.action')) {
			$('nav.gnavi').animate({
				right: '-380'
			});
			$('.DSbtn').removeClass('action');
		} else {
			$('nav.gnavi').animate({
				right: '0'
			});
			$('.DSbtn').addClass('action');
		}
	});
});
//アンカーリンク
$(function() {
	$('a[href^="#"]').click(function() {
		var speed = 1000;
		var href = $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top;
		$("html, body").animate({
			scrollTop: position
		}, speed, "swing");
		$('nav.gnavi').animate({
			right: '-380'
		});
		$('.DSbtn').removeClass('action');
		return false;
	});
});
//how to play mobile
$(function() {
	$('.flowBtn').click(function() {
		if ($(this).is('.open')) {
			$(this).next('.deatil').slideUp();
			$(this).removeClass('open');
		} else {
			$(this).next('.deatil').slideDown();
			$(this).addClass('open');
		}
	});
});
//読み込み完了後実行
window.onload = function() {
	$('#loader-bg').delay(900).fadeOut(800, function() {
		$(function() {
			setTimeout(function() {
				rect();
			}, 4000);
		});
	});
	$('#loader').delay(600).fadeOut(300);
	$('header').css('display', 'block');
	$('footer').css('display', 'block');
	$('#wrapper').css('display', 'block');
};
</script>